module.exports = __webpack_public_path__ + "static/media/rotation.c63653e3.svg";